import * as angular from "angular";

angular
  .module('bringoz.admin.wallets')
  .constant('AgentPaymentCollection_PN', {
    database: 'AgentPaymentCollection',
    isBranchEntity: false
  });
